import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "uk-container mt-10" }
const _hoisted_2 = { class: "uk-flex uk-flex-column uk-flex-center" }
const _hoisted_3 = {
  key: 0,
  class: "fa fa-check-circle"
}
const _hoisted_4 = {
  key: 0,
  class: "fa fa-check-circle"
}

import {Steppy} from 'vue3-steppy'
import {getCurrentInstance, ref, watch} from "vue";
import DetailsHeadingBloc from "@/views/booking/components/DetailsHeadingBloc.vue";
import NewCustormer from "@/views/booking/components/NewCustormer.vue";
import OldCustomer from "@/views/booking/components/OldCustomer.vue";
import StayStep from "@/views/booking/components/StayStep.vue";
import BookingResume from "@/views/booking/components/BookingResume.vue";
import {useStore} from "vuex";
import {useRouter} from "vue-router";
import Stay from "@/models/Stay";
import Customer from "@/models/Customer";
import LoadingSpinner from "@/shared/components/loading/LoadingSpinner.vue";
const backTitle = "Précédent";
const nextTitle = "Suivant";
const color = "#D62F2F";
const sizeCircle = 58;
const doneTitle = "Réserver";

export default /*@__PURE__*/_defineComponent({
  __name: 'BookingStep',
  setup(__props) {

const { $alert } = getCurrentInstance().appContext.config.globalProperties;
const { $endpoint } = getCurrentInstance().appContext.config.globalProperties;
const { $axios } = getCurrentInstance().appContext.config.globalProperties;
const step = ref(1)
const router = useRouter()
const store = useStore()
const stepTitle = ref([
  {
    title: 'Enregistrement',
    iconSuccess: null,
    isValid: true
  },
  {
    title: 'Séjours',
    iconSuccess: null,
    isValid: true
  },
  {
    title: 'Resumé',
    iconSuccess: null,
    isValid: true
  }
]);
const isNewCustomer = ref(store.getters['booking/getIsNewCustomer']);
const load = ref(false);
watch(step, async (newStep) =>{
  if (newStep == 2 && store.getters["booking/getCustomer"] === null){
    step.value = 1
    $alert.fire({
      title: 'Ooops!',
      text: "Veuillez renseigné vos infos si vous nouveau ou entré votre contact si vous êtes déjà enregistré",
      icon: 'error',
      confirmButtonColor:'#D62F2F',
      confirmButtonText: 'Compris'
    })
  }else if (newStep == 3 && store.getters["booking/getStay"] === null){
    step.value = 2
    $alert.fire({
      title: 'Ooops!',
      text: "Veuillez renseigné les infos du séjours",
      icon: 'error',
      confirmButtonColor:'#D62F2F',
      confirmButtonText: 'Compris'
    })
  }
})
const oldCustomerFound = ()=>{
  step.value = 2
}
const newCustomerFound = ()=>{
  step.value = 2
}
const stayInfosSet= ()=>{
  step.value = 3
}
function  saveBooking(){
  load.value = true
  const stay:Stay = store.getters['booking/getStay']
  const customer:Customer =store.getters['booking/getCustomer']
  const isNewCustomer:boolean  = store.getters['booking/getIsNewCustomer']
  const customerBookData = {
    stay_data:stay,
    customer_data:customer,
    isNew:isNewCustomer,
    custId: isNewCustomer? null:customer.id
  }
$axios.post($endpoint.CreateBooking, customerBookData).then((resp_book:any) => {
  $alert.fire({
    title: 'Opération réussie !',
    text: resp_book.data.message,
    icon: 'success',
    confirmButtonColor:'#D62F2F',
    confirmButtonText: 'OK'
  })

  store.dispatch('booking/resetCustomer')
  store.dispatch('booking/resetStay')
  store.dispatch('room/resetRoomChoose')
  store.dispatch('booking_filter/resetRoomFilterData')
  setTimeout(()=>{
    load.value =false
  },1000)
  router.push('/apartments')
}).catch((err:any)=>{
  console.warn(err)
})
}
const cancelBooking = ()=>{
  store.dispatch('booking/resetCustomer')
  store.dispatch('booking/resetStay')
  store.dispatch('room_data/resetRoomFilterData')
  store.dispatch('booking_filter/resetRoomFilterData')
  router.go(-1)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (load.value)
      ? (_openBlock(), _createBlock(LoadingSpinner, { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode(DetailsHeadingBloc, {
      title: "Reservation de l'appart choisir",
      "sub-tile": "Procéder à l'enregistrement de votre reservation"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        class: "uk-button uk-button-default csa-btn uk-width-1-4@l uk-width-1-2@s uk-width-1-2@m uk-margin-large-top",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (cancelBooking()))
      }, "Annuler la reservation"),
      _createVNode(_unref(Steppy), {
        step: step.value,
        "onUpdate:step": _cache[6] || (_cache[6] = ($event: any) => ((step).value = $event)),
        tabs: stepTitle.value,
        "onUpdate:tabs": _cache[7] || (_cache[7] = ($event: any) => ((stepTitle).value = $event)),
        finalize: saveBooking,
        "onUpdate:finalize": _cache[8] || (_cache[8] = ($event: any) => ((saveBooking) = $event)),
        backText: backTitle,
        "onUpdate:backText": _cache[9] || (_cache[9] = ($event: any) => ((backTitle) = $event)),
        nextText: nextTitle,
        "onUpdate:nextText": _cache[10] || (_cache[10] = ($event: any) => ((nextTitle) = $event)),
        doneText: doneTitle,
        "onUpdate:doneText": _cache[11] || (_cache[11] = ($event: any) => ((doneTitle) = $event)),
        primaryColor1: color,
        "onUpdate:primaryColor1": _cache[12] || (_cache[12] = ($event: any) => ((color) = $event)),
        circleSize: sizeCircle,
        "onUpdate:circleSize": _cache[13] || (_cache[13] = ($event: any) => ((sizeCircle) = $event))
      }, {
        "1": _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _cache[16] || (_cache[16] = _createElementVNode("h4", null, "Merci de choisir la méthode d'enregistrement.", -1)),
            _createElementVNode("div", null, [
              _createElementVNode("button", {
                class: "uk-button uk-button-default csa-btn",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (isNewCustomer.value = true))
              }, [
                _cache[14] || (_cache[14] = _createTextVNode("S'enregistrer ", -1)),
                (isNewCustomer.value)
                  ? (_openBlock(), _createElementBlock("i", _hoisted_3))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("button", {
                class: "uk-button uk-button-default csa-btn",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (isNewCustomer.value = false))
              }, [
                _cache[15] || (_cache[15] = _createTextVNode("Déjà enregistré ", -1)),
                (!isNewCustomer.value)
                  ? (_openBlock(), _createElementBlock("i", _hoisted_4))
                  : _createCommentVNode("", true)
              ])
            ]),
            (isNewCustomer.value)
              ? (_openBlock(), _createBlock(NewCustormer, {
                  key: 0,
                  onCustomerSave: _cache[3] || (_cache[3] = ($event: any) => (newCustomerFound()))
                }))
              : _createCommentVNode("", true),
            (!isNewCustomer.value)
              ? (_openBlock(), _createBlock(OldCustomer, {
                  key: 1,
                  onCustomerFound: _cache[4] || (_cache[4] = ($event: any) => (oldCustomerFound()))
                }))
              : _createCommentVNode("", true)
          ])
        ]),
        "2": _withCtx(() => [
          _createVNode(StayStep, {
            onStayInfosSave: _cache[5] || (_cache[5] = ($event: any) => (stayInfosSet()))
          })
        ]),
        "3": _withCtx(() => [
          _createVNode(BookingResume)
        ]),
        _: 1
      }, 8, ["step", "tabs"])
    ])
  ], 64))
}
}

})